export default "__VITE_ASSET__De_tPyVB__"